import React from 'react';
import { ui } from './ui';
import { TYPE_LABEL, SECTION_TITLES } from './aiPaperUtils';

// Stable top-level components (never defined inside a render body → no focus loss)
export const Field = ({ label, children }) => (
  <div style={{ marginBottom: 10 }}>
    <label style={ui.label}>{label}</label>
    {children}
  </div>
);

export const TextInput = ({ value, onChange, ...rest }) => (
  <input style={ui.input} value={value ?? ''} onChange={(e) => onChange(e.target.value)} {...rest} />
);

export const SelectInput = ({ value, onChange, options }) => (
  <select style={ui.input} value={value} onChange={(e) => onChange(e.target.value)}>
    {options.map((o) => <option key={o} value={o}>{o}</option>)}
  </select>
);

export const NumInput = ({ value, onChange, min = 0, max = 99, width = 64 }) => (
  <input type="number" min={min} max={max} style={{ ...ui.input, width, padding: '6px 8px' }}
    value={value} onChange={(e) => onChange(e.target.value === '' ? '' : Math.max(min, Math.min(max, Number(e.target.value))))} />
);

const NOTES = { A: '1 mark each', B: '2–3 marks each', C: '4–5 marks each', D: '5 marks each' };

export const SectionCard = ({ section, onToggle, onRow, onExtra }) => {
  const sectionTotal = section.rows.reduce((a, r) => a + (Number(r.count) || 0) * (Number(r.marks) || 0), 0);
  const canChoice = section.name !== 'A' && section.rows.length === 1;
  return (
    <div style={{ ...ui.card, opacity: section.enabled ? 1 : 0.55, marginBottom: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: section.enabled ? 8 : 0 }}>
        <input type="checkbox" checked={section.enabled} onChange={() => onToggle(section.name)} style={{ width: 18, height: 18 }} />
        <div style={{ fontWeight: 800, color: '#1e1b4b', flex: 1 }}>
          Section {section.name} — {SECTION_TITLES[section.name]}
          <span style={{ fontWeight: 600, fontSize: 12, color: '#64748b' }}> ({NOTES[section.name]})</span>
        </div>
        <div style={{ fontWeight: 800, color: '#4338ca' }}>{section.enabled ? `${sectionTotal} marks` : 'off'}</div>
      </div>
      {section.enabled && section.rows.map((r, i) => (
        <div key={r.type} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
          <div style={{ width: 150, fontSize: 13, fontWeight: 600 }}>{TYPE_LABEL[r.type]}</div>
          <NumInput value={r.count} onChange={(v) => onRow(section.name, i, 'count', v)} max={40} />
          <span style={{ fontSize: 12, color: '#64748b' }}>questions ×</span>
          <NumInput value={r.marks} onChange={(v) => onRow(section.name, i, 'marks', v)} min={1} max={10} />
          <span style={{ fontSize: 12, color: '#64748b' }}>mark(s)</span>
        </div>
      ))}
      {section.enabled && canChoice && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, fontSize: 13, flexWrap: 'wrap' }}>
          <input type="checkbox" checked={section.extra > 0} onChange={(e) => onExtra(section.name, e.target.checked ? 1 : 0)} style={{ width: 16, height: 16 }} />
          <span>Internal choice: add</span>
          <NumInput value={section.extra} onChange={(v) => onExtra(section.name, Number(v) || 0)} max={10} width={56} />
          <span>extra — "Attempt any {section.rows[0].count} out of {Number(section.rows[0].count) + Number(section.extra)}"</span>
        </div>
      )}
    </div>
  );
};
